// extracted by mini-css-extract-plugin
export default {"aiText":"mb37sS","copilotWelcomeScreen":"u_eWbC","copilotWelcomeScreenHeading":"tAkR5h"};